import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {ChevronDown} from "lucide-react";
import React, {useState} from "react";
import {color, font, radius, type} from "common/tokens";

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
  },
  section: {
    borderBottom: `1px solid ${color.DIVIDER}`,
    paddingBottom: 10,
  },
  sectionLabel: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.SECTION_TITLE,
    margin: 0,
  },
  plainLabel: {
    ...type.body,
    fontWeight: font.SEMIBOLD,
    color: color.TEXT,
    margin: 0,
  },
  count: {
    ...type.label,
    background: color.ACCENT_TINT,
    color: color.ACCENT_TEXT,
    borderRadius: radius.PILL,
    padding: '2px 8px',
  },
  spacer: {
    flex: 1,
  },
  chevron: {
    color: color.TEXT_MUTED,
    transition: 'transform 150ms ease',
    flexShrink: 0,
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  body: {
    paddingTop: 16,
  },
});

const Accordion = ({label, count, defaultOpen = false, variant = 'section', children}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={classes.root}>
      <button
        type={'button'}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        className={classNames(classes.header, variant === 'section' && classes.section)}
      >
        <p className={variant === 'section' ? classes.sectionLabel : classes.plainLabel}>{label}</p>
        {Boolean(count) && <span className={classes.count}>{count}</span>}
        <span className={classes.spacer}/>
        <ChevronDown
          size={18}
          strokeWidth={2}
          className={classNames(classes.chevron, open && classes.chevronOpen)}
        />
      </button>
      {open && <div className={classes.body}>{children}</div>}
    </div>
  );
};

export default Accordion;
